import { render } from "./InClassCriteria.vue?vue&type=template&id=0589860b"
import script from "./InClassCriteria.vue?vue&type=script&lang=js"
export * from "./InClassCriteria.vue?vue&type=script&lang=js"

import "./InClassCriteria.vue?vue&type=style&index=0&id=0589860b&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__